/*
payment/common/lib/utils/router-config.js

Settings for the view in depositflow.

content of : Title, back-, skip-, and close-buttons

The setup is exported and used by the navigation, components/deposit-bonus.js and other components/deposit-*****.js

*/

import merge from 'lodash-es/merge.js';
import bonus from './../../../bonus/index.js';
import navDeposit from './../../../navdeposit/index.js';
import pendingwithdrawals from './../../../pendingwithdrawals/index.js';
import payment from './../../../payment/index.js';
import config from './../../../../store/index.js';
import {
	lastProduct
} from '../../../../store/cookies.js';

const isLandingPage = config.page && config.page === 'landing';

function closeStepsDepositflow(step) {
	if (step.bonus) {
		bonus.close();
	}

	if (step.pendingwithdrawals) {
		pendingwithdrawals.close();
	}
	if (step.payment) {
		payment.close();
	}
}

function closebtnDepositBonusNpCb() {
	bonus.close();
	navDeposit.close();
}

function closebtnDepositWithdrawCb() {
	pendingwithdrawals.close();
	navDeposit.close();
}

function closebtnAccountPendingWithdrawalsCb() {
	pendingwithdrawals.close();
	navDeposit.close();
}
/* see mobile-core-assets/templates/html/account/deposit-main.mustache */
function getConfig(addToConfig) {
	return merge({
		wrap: {
			selector: '#js-deposit-flow'
		},
		skip: {
			selector: '#js-deposit-skip-btn',
			url: null,
			cb: null,
			isPush: true
		},
		close: {
			selector: '#js-deposit-close-btn',
			url: null,
			cb: null,
			isPush: true
		},
		back: {
			selector: '#js-deposit-back-btn',
			url: null,
			cb: null,
			isPush: true
		},
		title: {
			selector: '#js-deposit-header-title'
		},
		textkeys: {
			selector: '.textkeys__payments'
		}
	}, addToConfig);
}

const confAccountPendingWithdrawals = getConfig({
	flowname: 'account/pendingwithdrawals',
	close: {
		selector: '#js-deposit-close-btn',
		url: '/account',
		cb: closebtnAccountPendingWithdrawalsCb
	},
	textkeys: {
		/* the domobject containing all parsed textstrings */
		title: 'deposit-pendingwithdrawals-header-title' /* see textkeys-payment.mustache for the keys to the textkeys */
	}
});

const confDepositBonus = getConfig({
	/* configuration for bonus when pendingwithdrawals exist */
	flowname: 'deposit/bonus',
	skip: {
		url: '/account/deposit/payment',
		cb: bonus.close()
	},
	back: {
		url: '/account/deposit/withdraw',
		cb: bonus.close()
	},
	textkeys: {
		/* the domobject containing all parsed textstrings */
		title: 'deposit-bonus-title' /* see textkeys-payment.mustache for the keys to the textkeys */
	}
});

/* see mobile-core-assets/templates/html/account/deposit-main.mustache */
const confDepositBonusNp = getConfig({
	/* configuration for bonus when no pendingwithdrawals exist (Np)*/
	flowname: 'deposit/bonusnp',
	skip: {
		url: '/account/deposit/paymentnp',
		cb: bonus.close()
	},
	close: {
		url: '/account',
		cb: closebtnDepositBonusNpCb
	},
	textkeys: {
		/* the domobject containing all parsed textstrings */
		title: 'deposit-bonus-title' /* see textkeys-payment.mustache for the keys to the textkeys */
	}
});

const confDepositBonusFromRegister = getConfig({
	/* configuration for bonus when arriving from registration. No close button exits. */
	flowname: 'deposit/bonusFromRegister',
	skip: {
		url: '/account/deposit/payment?referrer=register',
		/* skip must go with referrer parameter identical to the line set in register/register.js:  ('/account/deposit/bonus?referrer=register');*/
		cb: bonus.close()
	},
	textkeys: {
		/* the domobject containing all parsed textstrings */
		title: 'deposit-bonus-title' /* see textkeys-payment.mustache for the keys to the textkeys */
	}
});

/* see mobile-core-assets/templates/html/account/deposit-main.mustache */
const confDepositWithdraw = getConfig({
	flowname: 'deposit/withdraw',
	skip: {
		url: '/account/deposit/bonus',
		cb: pendingwithdrawals.close()
	},
	close: {
		url: '/account',
		cb: closebtnDepositWithdrawCb
	},
	textkeys: {
		/* the domobject containing all parsed textstrings */
		title: 'deposit-pendingwithdrawals-header-title' /* see textkeys-payment.mustache for the keys to the textkeys */
	}
});

/* see mobile-core-assets/templates/html/account/deposit-main.mustache */
const confDepositPayment = getConfig({
	/* configuration for deposit when pendingwithdrawals and bonus exist */
	flowname: 'deposit/payment',
	back: {
		selector: '#js-deposit-back-btn',
		url: '/account/deposit/bonus',
		cb: payment.close()
	},
	textkeys: {
		/* the domobject containing all parsed textstrings */
		title: 'deposit-payment-title' /* see textkeys-payment.mustache for the keys to the textkeys */
	}
});

/* see mobile-core-assets/templates/html/account/deposit-main.mustache */
const confDepositPaymentNb = getConfig({
	/* configuration for deposit when no bonus exist (Nb)*/
	flowname: 'deposit/paymentnb',
	back: {
		url: '/account/deposit/withdraw',
		cb: payment.close()
	},
	textkeys: {
		/* the domobject containing all parsed textstrings */
		title: 'deposit-payment-title' /* see textkeys-payment.mustache for the keys to the textkeys */
	}
});

/* see mobile-core-assets/templates/html/account/deposit-main.mustache */
const confDepositPaymentNp = getConfig({
	/* configuration for deposit when no pendingwithdrawals exist (Np)*/
	flowname: 'deposit/paymentnp',
	back: {
		url: '/account/deposit/bonusnp',
		cb: payment.close()
	},
	textkeys: {
		/* the domobject containing all parsed textstrings */
		title: 'deposit-payment-title' /* see textkeys-payment.mustache for the keys to the textkeys */
	}
});

const confDepositPaymentFromRegister = getConfig({
	/* configuration for deposit when arriving from bonus which was entered during the registration */
	flowname: 'deposit/paymentregister',
	close: {
		url: '/global',
		isPush: lastProduct() || !isLandingPage
	},
	skip: {
		url: lastProduct() || !isLandingPage ? '/' : '/global',
		isPush: lastProduct() || !isLandingPage,
		cb: payment.close()
	},
	textkeys: {
		/* the domobject containing all parsed textstrings */
		title: 'deposit-payment-title' /* see textkeys-payment.mustache for the keys to the textkeys */
	}
});

const confDepositPaymentFromShop = getConfig({
	/* configuration for deposit when arriving from bonus which was entered during the registration */
	/* the textkeys.title is replaced by the title in payment method view. */
	flowname: 'deposit/paymentregister',
	back: {
		selector: '#js-deposit-back-btn',
		url: '/shop',
		cb: payment.close()
	},
	skip: {
		url: lastProduct() || !isLandingPage ? '/' : '/global',
		isPush: lastProduct() || !isLandingPage,
		cb: payment.close()
	},
	textkeys: {
		/* the domobject containing all parsed textstrings */
		// title: 'deposit-payment-title' /* see textkeys-payment.mustache for the keys to the textkeys */
	}
});

const confDepositPaymentNpNb = getConfig({
	/* configuration for deposit when no pendingwithdrawals (Np) and no bonus exist (Nb)*/
	flowname: 'deposit/paymentnpnb',
	close: {
		url: '/account'
	},
	textkeys: {
		/* the domobject containing all parsed textstrings */
		title: 'deposit-payment-title' /* see textkeys-payment.mustache for the keys to the textkeys */
	}
});

export {
	closeStepsDepositflow,
	confAccountPendingWithdrawals,
	confDepositBonus,
	confDepositBonusNp,
	confDepositBonusFromRegister,
	confDepositPaymentFromRegister,
	confDepositPaymentFromShop,
	confDepositWithdraw,
	confDepositPayment,
	confDepositPaymentNp,
	confDepositPaymentNb,
	confDepositPaymentNpNb
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/common/lib/utils/router-config.js